<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name 宛先種別
      span.validation-label 必須
    .register-value
      label.register-radio-label(v-if="enableUseSendTargetToAllFamily")
        input#type-0.register-radio-form(v-model="_innerType" name="type" type="radio" :value="_sendMessageType.ALL_FAMILY" v-validate="{ required: true }" data-vv-as="宛先種別")
        span.register-radio-text 家族全員
      label.register-radio-label(v-if="enableUseSendTargetToFamily")
        input#type-1.register-radio-form(v-model="_innerType" name="type" type="radio" :value="_sendMessageType.SELECTED_FAMILY")
        span.register-radio-text 家族個別
      label.register-radio-label(v-if="2 <= planType && enableUseSendTargetToOtherUser")
        input#type-2.register-radio-form(v-model="_innerType" name="type" type="radio" :value="_sendMessageType.SELECTED_OTHER_USER_GROUP")
        span.register-radio-text 施設関係者個別
      div(v-show="planType < 2")
        label#disable-type-2.register-radio-label
          span.register-radio-text.disable 施設関係者個別
        b-popover(target="disable-type-2" triggers="hover" placement="top")
          template(v-slot:title) 施設関係者個別
          span 職員等のLINEにメッセージを送ることができます。
          br
          span ※ ベーシックプラン以上で使用可能
      label.register-radio-label(v-if="1 <= planType && (enableUseSendTargetToFamilySendMessageGroup || enableUseSendTargetToOtherUserSendMessageGroup)")
        input#type-3.register-radio-form(v-model="_innerType" name="type" type="radio" :value="_sendMessageType.SEND_MESSGE_GROUP")
        span.register-radio-text グループ
      div(v-show="planType < 1")
        label#disable-type-3.register-radio-label
          span.register-radio-text.disable グループ
        b-popover(target="disable-type-3" triggers="hover" placement="top")
          template(v-slot:title) グループ
          span 作成した宛先グループ、利用者グループ、施設関係者グループ宛にメッセージを送ることができます。
          br
          span ※ ライトプラン以上で使用可能
      
    .error-messages(v-if="errors.has('type')")
      div(v-for="error in errors.collect('type')")
        label.error-message {{ error }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { PlanType } from "@/commons/services/Plans";
import { SendMessageType } from "@/commons/services/SendMessages";

@Component({
  inject: ["$validator"]
})
export default class SendMessageTargetType extends Vue {
  @Prop({ type: String, default: "" }) value!: string;
  @Prop({ type: Number, required: true }) planType!: PlanType;
  @Prop({ type: Boolean, default: false }) enableUseSendTargetToAllFamily!: boolean;
  @Prop({ type: Boolean, default: false }) enableUseSendTargetToFamily!: boolean;
  @Prop({ type: Boolean, default: false }) enableUseSendTargetToOtherUser!: boolean;
  @Prop({ type: Boolean, default: false }) enableUseSendTargetToFamilySendMessageGroup!: boolean;
  @Prop({ type: Boolean, default: false }) enableUseSendTargetToOtherUserSendMessageGroup!: boolean;

  get _sendMessageType(): typeof SendMessageType {
    return SendMessageType;
  }

  get _innerType(): string {
    return this.value;
  }
  set _innerType(val: string) {
    this.$emit("input", val);
  }
}
</script>
